export default "__VITE_ASSET__iMe3n9VA__"